<header id="page-topbar">
    <div class="navbar-header">
        <div class="navbar-brand-box" >
            <div class="logo-hamburger">
                <a href="javascript: void(0)" class="logo logo-dark">
                    <span class="logo-lg"><img [src]="imageSource" alt=""></span>
                </a>
                <a href="javascript: void(0)" class="logo logo-light">
                    <span class="logo-lg"><img  [src]="imageSource" alt=""></span>
                </a>
                @if(claims.orgRoleId == 3){<div class="sidebar-hamburger-icon">
                    <img id="vertical-menu-btn" [src]="showMenuButton ? ICONS.SIDEBAR_LEFT : ICONS.SIDEBAR_RIGHT" alt="" 
                    (click)="toggleMobileMenu()">
                </div>}
                <ds-dashboard-action-btn class="nav-menu-mobile"
                    [id]="'toggle-navmenu-btn'"
                    [actionItem]="'Top Menu'"
                    [iconSrc]="ICONS.CHEVRON_RIGHT"
                    (click)="toggleNavMenu()">
                </ds-dashboard-action-btn>
            </div>
            <app-nav-menu [id]="'app-nav-menu'" [hidden]="isMobileView" (mobileMenuButtonClicked)="toggleMobileMenu()" (toggleRightSidebarEvent)="toggleRightSidebar()"></app-nav-menu>
        </div>
    </div>
</header>